import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

const reveal = (i = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
});

const MenuCard = ({ idx, title, name, desc, testid }) => (
  <motion.div
    {...reveal(idx)}
    data-testid={testid}
    className="relative bg-white border border-olive/10 rounded-2xl p-10 md:p-12 flex flex-col items-center text-center shadow-[0_8px_30px_rgb(107,45,49,0.05)] transition-transform duration-700 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(107,45,49,0.1)]"
  >
    <div className="absolute top-6 right-6 font-serif text-xs text-gold tracking-[0.3em]">
      0{idx + 1}
    </div>
    <p className="text-[11px] tracking-[0.4em] uppercase text-olive mb-4">{title}</p>
    <h3 className="font-serif text-3xl md:text-4xl text-wine mb-6">{name}</h3>
    <div className="w-12 h-px bg-gold mb-6" />
    <p className="font-editorial italic text-lg text-charcoal leading-relaxed max-w-sm">{desc}</p>
  </motion.div>
);

const Menu = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="menu-section"
      className="py-28 md:py-40 px-6"
      style={{ backgroundColor: "#F4F0E6" }}
    >
      <div className="max-w-5xl mx-auto">
        <motion.p {...reveal(0)} className="text-[11px] tracking-[0.4em] uppercase text-olive text-center mb-6">
          {t.menu.label}
        </motion.p>
        <motion.h2 {...reveal(1)} className="font-serif text-4xl md:text-5xl text-wine text-center mb-4">
          {t.menu.title}
        </motion.h2>
        <motion.p {...reveal(2)} className="font-editorial italic text-base md:text-lg text-olive text-center mb-16">
          {t.menu.subtitle}
        </motion.p>

        <div className="grid md:grid-cols-2 gap-8">
          <MenuCard
            idx={0}
            title="Mar"
            name={t.menu.option1.name}
            desc={t.menu.option1.desc}
            testid="menu-card-lubina"
          />
          <MenuCard
            idx={1}
            title="Tierra"
            name={t.menu.option2.name}
            desc={t.menu.option2.desc}
            testid="menu-card-iberico"
          />
        </div>
      </div>
    </section>
  );
};

export default Menu;
